import React from 'react';

export default function PassResetLinkToBeReceived() {
    
    return (
        <div>
            <p className="text-xl text-white">you’ll receive a password reset email.</p>
        </div>
    )
}

export function PassResetSuccessful() {

    return (
        <div>
            <p className="text-xl text-white">Your password has been successfully reset! You can now <a href='/login' className="text-blue-500">login</a></p>
        </div>
    )
}